import React, { useState, useEffect } from "react";
import source from "./data/loop.json";
import LoopProperty from "./loopproperty";

const Loop = () => {
  const [Loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div>
      <h1>Loop Property data</h1>
      <p style={{ marginBottom: "2rem" }}>
        <a href="/" title="Main Menu link">
          Return to main menu
        </a>
      </p>
      {Loading && <h4>Loading data...</h4>}

      {!Loading && (
        <>
          {source.data.map((itm) => (
            <LoopProperty Data={itm} key={itm.listingId} />
          ))}
        </>
      )}
    </div>
  );
};

export default Loop;
